import React,{Fragment, useEffect, useState} from 'react';
import ReactPlayer from "react-player";
import { getVideoData } from '../../../../api/salespro';
import { SALESPRO_VIDEO_IDS } from '../../constants/salespro_webpage';
import Image from '../../../../components/common/Image';
import styles from './playlist.module.scss';
import Config from '../../../../config';


const Playlist = (props) => {
    const [videoData, setVideoData] = useState<any>([]);
    const [viewLess, setViewLess] = useState(true);


    useEffect(()=>{
        const params = {
            key: Config.GOOGLE_MAP_KEY, 
            id: SALESPRO_VIDEO_IDS.join(','),
            part: ['snippet', 'status', 'statistics'].join(','),
          };
        getVideoData(params).then((res: any)=>{
            let data = res.data?.items
            if (data && data.length > 0) {
                data[0].highlighted = true;
              }
            setVideoData(data)
        }).catch((err:any)=>{
            console.log("err: ", err)
        })
    },[])

    const handleVideoSelect = (index) => {
        const updatedVideos = videoData.map((video, i) => ({
          ...video,
          highlighted: i === index,
        }));
        setVideoData(updatedVideos);
        setViewLess(true)
        props.setVideo('')
        const video: any = document.querySelector(`#playlist_video`)
        video?.scrollIntoView({behavior: 'smooth', block: 'center'})
    };

    const viewChange = () => {
        let description: any = document.getElementById('video_description');
        description.scrollTop = 0;
        setViewLess(!viewLess)
    }
    
    return (
    <Fragment>
        <div className={`${styles.parent_container} app-section`}>
            <h3 className={`app-section__title em ${styles.playlist_heading}`}>Know More About Us & Our Plans</h3>
            {
                videoData && 
                <div className={styles.playlist}>
                    <div className={styles.item_1}>
                        <div className={styles.list_heading}>
                            More Videos
                        </div>
                        <ul className={styles.video_list}>
                            {videoData.map((video, index) => (
                                <li
                                    key={index}
                                    onClick={() => handleVideoSelect(index)}
                                    className={`${styles.videos} ${video.highlighted?styles.highlighted:''}`}
                                >
                                    <div className={styles.image}>
                                        <Image src={video.snippet.thumbnails.maxres.url} alt={video.snippet.title} height="120px" width="240"/>
                                    </div>
                                    <div className={styles.details}>
                                        <p className={styles.details_title}>{video.snippet.title}</p>
                                        <p className={styles.details_description}>{video.snippet.description}</p>
                                        <div className={styles.views}><Image src={'/static/images/salespro/views.svg'} alt='views' height="16" width="16"/><p className={styles.view_count}>{video.statistics.viewCount} Views</p></div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={`${styles.main_video_section} ${styles.item_2}`}>
                        <div className={styles.main_heading}>
                            Get started with selling plans today with us
                        </div>
                        <div className={styles.main_video}>
                            {videoData.map((video, index) => (
                                video.highlighted && (
                                    <>
                                        <ReactPlayer
                                            id='playlist_video'
                                            url={'https://www.youtube.com/watch?v=' + video.id}
                                            height="100%"
                                            width="100%"
                                            playing={props.video=='playlist'}
                                            onPlay={() => {props.setVideo('playlist')}}
                                        />
                                        <div className={styles.views}><Image src={'/static/images/salespro/views.svg'} alt='views' height="16" width="16"/><p className={styles.view_count}>{video.statistics.viewCount} Views</p></div>
                                        <p className={styles.video_title}>{video.snippet.title}</p>
                                        <p id='video_description' className={`${viewLess ? styles.video_description_less : styles.video_description}`}>{video.snippet.description}</p>
                                        <span className={styles.read_more} onClick={viewChange}>Read {viewLess?'More':'Less'}</span>
                                    </>
                                )
                            ))}
                        </div>
                    </div>
                </div>
            }
        </div>
    </Fragment>
    );
}

export default Playlist;
